<template>
  <div id="page3" class="page-container" :style="{ 'backgroundImage': 'url(\'' + bg_image + '\')' }">

      <div class="box w-516px pull-right">
          <h1 class="m-t-100">Durante as <span class="text-green">conversas</span><br> as pessoas parecem <br>murmurar?</h1>
          <div class="m-t-50">
            <b-button pill class="w-76 m-t-10 btn-answers" @click="computa(2, $event)">Sempre</b-button>
            <b-button pill class="w-76 m-t-10 btn-answers" v-on:click="computa(1.5, $event)">Frequentemente</b-button>
            <b-button pill class="w-76 m-t-10 btn-answers" v-on:click="computa(1, $event)">Às vezes</b-button>
            <b-button pill class="w-76 m-t-10 btn-answers" v-on:click="computa(0.5, $event)">Raramente</b-button>
            <b-button pill class="w-76 m-t-10 btn-answers" v-on:click="computa(0, $event)">Nunca</b-button>

            <div class="w-76 m-t-70">
              <b-button pill class="m-t-20 pull-left w-35" v-on:click="previous">Voltar</b-button>
              <b-button pill class="m-t-20 btn-success pull-right w-55 boldit" v-on:click="next">Seguinte</b-button>
            </div>
          </div>

      </div>
  </div>

</template>

<script>
import { bus } from '../main';

export default {

  name: "Cadastre",
  data() {
      return {
        form: {
          nome: ''
        },
        show: true,
        answer_selected: false,
        bg_image: require('../../assets/page3-bg.png')
      }
    },
    props:['count'],
    methods: {
      next() {
        if (this.answer_selected == false) {
            alert('Por favor, selecione uma resposta');
            return false;
        }
        this.$router.push('page4')

      },
      computa(peso, $event) {
        var x = document.getElementsByClassName("btn-answers");
        var i;
        for (i = 0; i < x.length; i++) {
          x[i].classList.remove("btn-success");
        }

        //$event.currentTarget.style = 'background-color:#96c303 !important;';
        $event.currentTarget.classList.add("btn-success");
        console.log($event.currentTarget.dataWeight);
        console.log($event.toElement);

        console.log(peso);
        bus.$emit('computaPontuacao', {question:3, answer: peso});
        this.answer_selected = true;
        //$emit('computa-pontuacao')
        //console.log(this.count)
        //this.count = 10
      },
      previous() {
        this.$router.push('page2')
      }
    }
}
</script>

<style scoped>


#page3 #box {

}
</style>
